import React, { useEffect, useState } from "react";
import api from "../api/api";
import "../styles/health.css";

const Health = () => {
  const [healthData, setHealthData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  // Fetch health data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("health/");
        setHealthData(res.data || []);
      } catch (err) {
        console.error("Health API Error:", err);
        setError("Failed to load health data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ESC key to close modal & prevent scroll
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };

    if (selectedImage) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleEsc);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => window.removeEventListener("keydown", handleEsc);
  }, [selectedImage]);

  if (loading) return <p style={{ textAlign: "center" }}>Loading health data...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;
  if (!healthData.length) return <p style={{ textAlign: "center" }}>No health data available</p>;

  return (
    <div className="health-container">
      <h1 className="health-heading">Health Programs</h1>

      {healthData.map((item) => (
        <div key={item.id} className="health-card">
          <h3>{item.title}</h3>
          <p>{item.description}</p>

          <div className="health-images">
            {item.images?.map((img) => {
              const imageUrl = img.image.startsWith("http")
                ? img.image
                : `http://127.0.0.1:8000${img.image}`;

              return (
                <img
                  key={img.id}
                  src={imageUrl}
                  alt="health"
                  className="health-image"
                  onClick={() => setSelectedImage(imageUrl)}
                />
              );
            })}
          </div>
        </div>
      ))}

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
          onClick={() => setSelectedImage(null)} // click outside closes
        >
          <div
            style={{ cursor: "default", position: "relative" }}
            onClick={(e) => e.stopPropagation()} // click image does NOT close
          >
            <span
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                fontSize: "2rem",
                color: "#fff",
                cursor: "pointer",
              }}
              onClick={() => setSelectedImage(null)}
            >
              ×
            </span>
            <img
              src={selectedImage}
              alt="popup"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                borderRadius: "12px",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Health;